export const picklist = function (picklist) {
    var $picklist = $(picklist);

    $picklist.autocomplete({
        source: function (request, response) {
            $.getJSON($(this.element[0]).attr('data-adapt-source'), {
                q: request.term
            }, response);
        },
        appendTo: $picklist.parent().parent(),
        select: function (event, ui) {
            var parts = ui.item.value.split(/-/);
            var icon = "";
            var object_type = "";
            var object_id = "";
            var display = "";
            if (parts.length > 4) {
                for (var i = 4; i < parts.length; i++) {
                    parts[3] = parts[3] + "-" + parts[i];
                }
            }
            if (parts.length >= 4) {
                icon = parts[0];
                object_type = parts[1];
                object_id = parts[2];
                display = parts[3];
            } else {
                object_type = parts[0];
                object_id = parts[1];
                display = parts[2];
            }

            const $container = $(this).parents('.view.form-group').next('.picklist_container');

            var button = " <a href=\"#\" class=\"control remove_tag\"><i class=\"view icon fa fa-times\"></i></a>";
            var input = "<input type=\"hidden\" name=\"" + $(this).attr('data-adapt-name') + "[]\" value=\"" + object_type + "-" + object_id + "\" data-adapt-value=\"" + object_type + "-" + object_id + "\">";
            var html = "<span class=\"view tag\"><i class=\"view icon fa fa-" + icon + "\"></i><span> " + display + "</span>" + input + button + "</span>";

            $container.append(html);
            this.value = "";
            $('.view.tag .control.remove_tag').on('click', function () {
                $(this).parent('.view.tag').detach();
            });
            return false;
        },
    });

    $('.view.tag .control.remove_tag').on('click', function () {
        $(this).parent('.view.tag').detach();
    });
};

export const taglist = function (picklist) {
    var $picklist = $(picklist);

    $picklist.autocomplete({
        source: function (request, response) {
            $.getJSON($(this.element[0]).attr('data-adapt-source'), {
                q: request.term
            }, response);
        },
        appendTo: $picklist.parent().parent(),
        select: function (event, ui) {
            const $container = $(this).parents('.view.form-group').next('.picklist_container');
            var button = " <a href=\"#\" onclick=\"$(this).parent('.view.tag').detach()\"><i class=\"view icon fa fa-times\"></i></a>";
            var input = "<input type=\"hidden\" name=\"" + $(this).attr('data-adapt-name') + "[]\" value=\"" + ui.item.label + "\">";
            var html = "<span class=\"view tag\"><i class=\"view icon fa fa-tag\"></i> " + ui.item.label + input + button + "</span>";

            $container.append(html);
            this.value = "";
            return false;
        },
    });

};

export const initPicklists = function () {
    $('input.autocomplete').each(function () {
        new picklist(this);
    });

    $('input.tagger').each(function () {
        new taglist(this);
    });

    $('.date-picker').on('change', function () {
        $(this).datepicker('setDate', $(this).datepicker('getDate'));
    })

    $('.date-picker').each(function () {
        $(this).datepicker({
            firstDay: 1,
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            yearRange: '-100:+1',
            minDate: $(this).data('mindate') || "-100y",
            maxDate: $(this).data('maxdate') || "+1y"
        });
    });
    $('.time-picker').timepicker({
        timeFormat: "H:i",
        step: 15,
        scrollDefaultNow: true
    });
};